var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-light" },
    [
      _c("Heading", {
        staticClass: "mb-md-5 text-center",
        attrs: { title: _vm.$t("login_auth"), routeName: "vignette" },
      }),
      _c("div", { staticClass: "container container-small bg-md-white" }, [
        _c("p", { staticClass: "heading heading-small" }, [
          _vm._v(_vm._s(_vm.$t("login_login_into_your_account"))),
        ]),
        _c("div", { staticClass: "bg-white" }, [_c("LoginComponent")], 1),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }